import { toolkitUrls } from '@/links'

export async function getRecentlyViewedContent(userUuid, contentType, limit) {
  let url = `${toolkitUrls.api}/library/${userUuid}/recently_viewed/${contentType}`
  if (limit) {
    url += `?limit=${limit}`
  }
  try {
    const response = await fetch(url, {
      method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
      credentials: 'include'
    })
    return await response.json()
  } catch (e) {
    throw new Error(`Failed to get recently viewed ${contentType}`, { cause: e })
  }
}
